/**
 * @type {{getTpl: Api.getTpl, templates: {}, send: (function(*=, *=, *=, *=): *)}}
 */
import Notify from "./components/Notify";

const Api = {
    templates: {},

    getTpl: function (name, extra = null) {
        const self = this;
        const def = $.Deferred();
        const path = "/api/template/admin";
        const data = {
            name: name
        };

        if (extra != null) {
            data.extra = extra;
        }

        if (self.templates[name]) {
            def.resolve(self.templates[name]);
            return def.promise();
        }

        const jxhr = this.send(path, data);

        $.when(jxhr).done(r => {
            if (extra == null) {
                Api.templates[name] = r.tpl;
            }
            def.resolve(r.tpl);
        });

        return def.promise();
    },

    /**
     * XHR Requests
     * @param url
     * @param data
     * @param method
     * @param dataType
     */
    send: function (url, data, method, dataType) {

        if (!data) {
            data = {};
        }

        //Default to GET
        if (!method) {
            method = 'get';
        }

        if (!dataType) {
            dataType = 'json';
        }

        //Default host
        if (!data.app) {
            data.app = $('[data-app]').data('app');
        }
        if (!data.locale) {
            data.locale = $('[data-locale]').data('locale');
        }

        //Limitation for POST PUT
        if ((method === 'post' || method === 'put' || method === 'patch') && dataType === 'json') {
            data = JSON.stringify(data);
        }

        let options = {
            type: method,
            data: data,
            dataType: 'json',
            contentType: 'application/json',
            url: url
        };

        // FormData submission
        if (dataType === 'formdata') {
            delete options.dataType;
            options.contentType = false;
            options.processData = false;
        }

        if (method === "get") {
            options.dataType = "jsonp";
        }

        return $.ajax(options)
            .fail(function (xhr, err) {
                const error = url + " says: " + JSON.stringify(xhr) + " " + JSON.stringify(err);
                console.log(JSON.stringify(error));
                if (xhr.status === 401) {
                    Notify('Permission denied.', 'warn');
                } else if (xhr.status === 400) {
                    Notify(xhr.responseText, 'warn', 2000);
                } else if (xhr.status === 419) {
                    window.location.reload();
                } else if (xhr.status === 422) {
                    const response = JSON.parse(xhr.responseText);
                    let msg = response.message;
                    const errors = response.errors;
                    for (let i in errors) {
                        if (errors.hasOwnProperty(i)) {
                            msg += ` ${i}: ${errors[i].join(', ')}`;
                        }
                    }
                    Notify(msg, 'warn', 4000);
                }
            });
    },
};

export default Api;
